import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from '../store/index';

//导入Hello组件
import HomePage from '../views/HomePage.vue'
import link from '../views/link.vue'
import plan from '../views/plan.vue'
import service from '../views/service.vue'
import visitor from '../views/visitor.vue'
import aboutus from '../views/aboutus.vue'
import list from '../views/list.vue'
import detail from '../views/detail.vue'
import search from '../views/search.vue'
import eightGragon from '../views/eightGragon.vue'
// 子页面
import homePageVideo from '../views/homePage/video.vue'
import homePageTrends from '../views/homePage/trends.vue'
import homePageNotice from '../views/homePage/notice.vue'
import homePageMethod from '../views/homePage/method.vue'
import homePageMethodInfo from '../views/homePage/methodInfo.vue'
import linkEnjoy from '../views/link/enjoy.vue'
import linkEnjoyInfo from '../views/link/enjoyInfo.vue'
import linkCultureHeritage from '../views/link/cultureHeritage.vue'
import CultureInfo from '../views/link/cultureInfo.vue'
import linkNatureHeritage from '../views/link/natureHeritage.vue'
import natureInfo from "~/views/link/natureInfo.vue";
import linkVideo from '../views/link/video.vue'
import pictureList from '../views/link/pictureList.vue'
import linkPicture from '../views/link/picture.vue'
import linkDetail from '../views/link/detail.vue'
import linkJingdian from '../views/link/jingdian.vue'
import planDelicious from '../views/plan/delicious.vue'
import planDeliciousInfo from '../views/plan/deliciousInfo.vue'
import planStay from '../views/plan/stay.vue'
import stayInfo from "~/views/plan/stayInfo.vue";
import planHappy from '../views/plan/happy.vue'
import planHappyInfo from '../views/plan/happyInfo.vue'
import planShopping from '../views/plan/shopping.vue'
import planShoppingInfo from '../views/plan/shoppingInfo.vue'
import planActivity from '../views/plan/activity.vue'
import planActivityInfo from '../views/plan/activityInfo.vue'
import serviceRoute from '../views/service/route.vue'
import serviceRouteInfo from '../views/service/routeInfo.vue'
import serviceProduction from '../views/service/production.vue'
import serviceProductionInfo from '../views/service/productionInfo.vue'
import serviceStrategy from '../views/service/strategy.vue'
import serviceStrategyInfo from '../views/service/strategyInfo.vue'
import visitorQuestion from '../views/visitor/question.vue'
import visitorQuestionnaire from '../views/visitor/questionnaire.vue'
import visitorActivityNew from '../views/visitor/activityNew.vue'
import visitorActivityInfo from '../views/visitor/activityInfo.vue'
import searchInfo from '../views/search/searchInfo.vue'
// 英文网站
import EnglishIndex from '../views/english/index.vue'
import EnglishList from '../views/english/list.vue'
import PlayStay from '../views/english/PlayStay.vue'
import Hotel from '../views/english/PlayStay/Hotel.vue'
import HotelDetail from '../views/english/PlayStay/HotelDetail.vue'
import HowToPlay from '../views/english/PlayStay/HowToPlay.vue'
import HowToPlayDetail from '../views/english/PlayStay/HowToPlayDetail.vue'
import Gift from '../views/english/PlayStay/Gift.vue'
import GiftDetail from '../views/english/PlayStay/GiftDetail.vue'
import Culture from '../views/english/Culture.vue'
import Buddhist from '../views/english/Culture/Buddhist.vue'
import BuddhistDetail from '../views/english/Culture/BuddhistDetail.vue'
import Martial from '../views/english/Culture/Martial.vue'
import MartialDetail from '../views/english/Culture/MartialDetail.vue'
import Tea from '../views/english/Culture/Tea.vue'
import TeaDetail from '../views/english/Culture/TeaDetail.vue'
import Food from '../views/english/Culture/Food.vue'
import FoodDetail from '../views/english/Culture/FoodDetail.vue'
import Events from '../views/english/Events/Events.vue'
import EventsDetail from '../views/english/Events/EventsDetail.vue'
import TravelInfo from '../views/english/TravelInfo.vue'
import EnVideos from '../views/english/TravelInfo/Videos.vue'
import EnPictures from '../views/english/TravelInfo/Pictures.vue'
import EnAboutUs from '../views/english/TravelInfo/AboutUs.vue'
import Notice from '../views/english/TravelInfo/Notice.vue'
import NoticeDetail from '../views/english/TravelInfo/NoticeDetail.vue'

//在Vue中使用路由
Vue.use(VueRouter)

const router = new VueRouter({
	//默认为hash模式,在history模式下地址栏的#号会隐藏
	mode: 'history',
	base: '/new/',
	routes: [{
			path: '/',
			redirect: 'home',
			name: '',
		},
		{
			path: '/home',
			name: 'HomePage',
			meta: {
				title: '峨眉山景区官网：四川自驾游,奇观,拜佛,休闲,养生,旅游胜地 - 峨眉山旅游网'
			},
			component: HomePage,
			children: [{
					path: 'videos',
					meta: {
						title: '景区视频'
					},
					component: homePageVideo
				},
				{
					path: 'trends',
					meta: {
						title: '经典线路'
					},
					component: homePageTrends
				},
				{
					path: 'notice',
					meta: {
						title: '通知公告'
					},
					component: homePageNotice
				},
				{
					path: 'method',
					meta: {
						title: '攻略推荐'
					},
					component: homePageMethod,
					children: [{
						path: 'info',
						// meta: {
						//     title: '攻略详情'
						// },
						component: homePageMethodInfo
					}]
				},
			]
		}, {
			path: '/link',
			meta: {
				title: '圣地峨眉'
			},
			component: link,
			children: [{
					path: 'enjoy',
					meta: {
						title: '精彩体验'
					},
					component: linkEnjoy,
					children: [{
						path: 'info',
						// meta: {
						//     title: '四季游峨眉'
						// },
						component: linkEnjoyInfo,
					}]
				},
				{
					path: 'culture',
					meta: {
						title: '文化遗产'
					},
					component: linkCultureHeritage,
					children: [{
						path: 'info',
						// meta: {
						//     title: '文章详情'
						// },
						component: CultureInfo,
					}]
				},
				{
					path: 'nature',
					meta: {
						title: '自然遗产'
					},
					component: linkNatureHeritage,
					children: [{
						path: 'info',
						// meta: {
						//     title: '文章详情'
						// },
						component: natureInfo,
					}]
				},
				{
					path: 'videos',
					meta: {
						title: '景区视频'
					},
					component: linkVideo
				},
				{
					path: 'pictureList',
					meta: {
						title: '精美图库'
					},
					component: pictureList
				},
				{
					path: 'pictures',
					meta: {
						title: '精美图库'
					},
					component: linkPicture,
				},
				{
					path: 'detail',
					meta: {
						title: '景区简介',
					},
					component: linkDetail
				},
				{
					path: 'jingdian',
					meta: {
						title: '标志景点',
					},
					component: linkJingdian
				}
			]
		}, {
			path: '/plan',
			meta: {
				title: '玩转峨眉'
			},
			component: plan,
			children: [{
					path: 'delicious',
					meta: {
						title: '吃得巴适'
					},
					component: planDelicious,
					children: [{
						path: 'info',
						// meta: {
						//     title: '文章详情'
						// },
						component: planDeliciousInfo
					}]
				},
				{
					path: 'stay',
					meta: {
						title: '住得舒适'
					},
					component: planStay,
					children: [{
						path: 'info',
						// meta: {
						//     title: '文章详情'
						// },
						component: stayInfo
					}]
				},
				{
					path: 'happy',
					meta: {
						title: '玩的安逸'
					},
					component: planHappy,
					children: [{
						path: 'info',
						// meta: {
						//     title: '文章详情'
						// },
						component: planHappyInfo
					}]
				},
				{
					path: 'shopping',
					meta: {
						title: '购的开心'
					},
					component: planShopping,
					children: [{
						path: 'info',
						// meta: {
						//     title: '文章详情'
						// },
						component: planShoppingInfo
					}]
				},
				{
					path: 'activity',
					meta: {
						title: '节庆活动'
					},
					component: planActivity,
					children: [{
						path: 'info',
						// meta: {
						//     title: '文章详情'
						// },
						component: planActivityInfo
					}]
				}
			]
		}, {
			path: '/service',
			meta: {
				title: '旅游攻略'
			},
			component: service,
			children: [{
					path: 'route',
					meta: {
						title: '经典路线'
					},
					component: serviceRoute,
					children: [{
						path: 'info',
						// meta: {
						//     title: '路线详情'
						// },
						component: serviceRouteInfo
					}]
				},
				{
					path: 'production',
					meta: {
						title: '主题产品'
					},
					component: serviceProduction,
					children: [{
						path: 'info',
						// meta: {
						//     title: '详情'
						// },
						component: serviceProductionInfo
					}]
				},
				{
					path: 'strategy',
					meta: {
						title: '达人攻略'
					},
					component: serviceStrategy,
					children: [{
						path: 'info',
						// meta: {
						//     title: '详情'
						// },
						component: serviceStrategyInfo
					}]
				},
			]
		}, {
			path: '/visitor',
			meta: {
				title: '游客服务'
			},
			component: visitor,
			children: [{
					path: 'question',
					meta: {
						title: '常见问题'
					},
					component: visitorQuestion
				},
				{
					path: 'questionnaire',
					meta: {
						title: '问卷调研'
					},
					component: visitorQuestionnaire
				},
				{
					path: 'activity',
					meta: {
						title: '活动资讯'
					},
					component: visitorActivityNew,
					children: [{
						path: 'info',
						// meta: {
						//     title: '活动详情'
						// },
						component: visitorActivityInfo
					}]
				},
			]
		}, {
			path: '/aboutus',
			meta: {
				title: '关于我们'
			},
			component: aboutus
		}, {
			path: '/list',
			meta: {
				title: '列表'
			},
			component: list
		}, {
			path: '/detail',
			meta: {
				title: '详情'
			},
			component: detail
		}, {
			path: '/search',
			meta: {
				title: '搜索'
			},
			component: search,
			children: [{
				path: 'info',
				// meta: {
				//     title: '文章详情'
				// },
				component: searchInfo
			}]
		}, {
			path: '/eightGragon',
			meta: {
				title: '八部天龙'
			},
			component: eightGragon,
		},
		{
			path: '/PlayStay',
			meta: {
				title: 'PlayStay'
			},
			component: PlayStay,
			children: [{
				path: 'Hotel',
				meta: {
					title: 'Hotel'
				},
				component: Hotel,
				children: [{
					path: 'HotelDetail',
					// meta: {
					// 	title: 'HotelDetail'
					// },
					component: HotelDetail
				}]
			}, {
				path: 'HowToPlay',
				meta: {
					title: 'HowToPlay'
				},
				component: HowToPlay,
				children: [{
					path: 'HowToPlayDetail',
					// meta: {
					// 	title: 'HowToPlayDetail'
					// },
					component: HowToPlayDetail
				}]
			}, {
				path: 'Gift',
				meta: {
					title: 'Gift'
				},
				component: Gift,
				children: [{
					path: 'GiftDetail',
					// meta: {
					// 	title: 'GiftDetail'
					// },
					component: GiftDetail
				}]
			}]
		},
		{
			path: '/Culture',
			meta: {
				title: 'Culture'
			},
			component: Culture,
			children: [{
				path: 'Buddhist',
				meta: {
					title: 'Buddhist Culture'
				},
				component: Buddhist,
				children: [{
					path: 'BuddhistDetail',
					// meta: {
					// 	title: 'BuddhistDetail'
					// },
					component: BuddhistDetail
				}]
			}, {
				path: 'Martial',
				meta: {
					title: 'Martial Arts Culture'
				},
				component: Martial,
				children: [{
					path: 'MartialDetail',
					// meta: {
					// 	title: 'MartialDetail'
					// },
					component: MartialDetail
				}]
			}, {
				path: 'Tea',
				meta: {
					title: 'Tea Culture'
				},
				component: Tea,
				children: [{
					path: 'TeaDetail',
					// meta: {
					// 	title: 'TeaDetail'
					// },
					component: TeaDetail
				}]
			}, {
				path: 'Food',
				meta: {
					title: 'Food Culture'
				},
				component: Food,
				children: [{
					path: 'FoodDetail',
					// meta: {
					// 	title: 'FoodDetail'
					// },
					component: FoodDetail
				}]
			}]
		},
		{
			path: '/Events',
			meta: {
				title: 'Events'
			},
			component: Events,
			children: [{
				path: 'EventsDetail',
				// meta: {
				// 	title: 'EventsDetail'
				// },
				component: EventsDetail
			}]
		}, {
			path: '/englishIndex',
			meta: {
				title: 'Index'
			},
			component: EnglishIndex
		}, {
			path: '/englishList',
			meta: {
				title: 'list'
			},
			component: EnglishList
		}, {
			path: '/TravelInfo',
			meta: {
				title: 'TravelInfo'
			},
			component: TravelInfo,
			children: [{
				path: 'Videos',
				meta: {
					title: 'Videos'
				},
				component: EnVideos
			}, {
				path: 'Pictures',
				meta: {
					title: 'Pictures'
				},
				component: EnPictures
			}, {
				path: 'AboutUs',
				meta: {
					title: 'About Us'
				},
				component: EnAboutUs
			}, {
				path: 'Notice',
				meta: {
					title: 'Notice'
				},
				component: Notice,
				children: [{
					path: 'NoticeDetail',
					// meta: {
					// 	title: 'NoticeDetail'
					// },
					component: NoticeDetail
				}]
			}]
		}
	]
});

router.beforeEach((to, from, next) => {
	// const home = router.getRoutes().find(a => a.path === '' || a.path === '/' );
	// let newPaths = [{path: '/', meta: home ? home.meta : {title: '首页'}}];
	if (to.path === '/') {
		document.title = '峨眉山旅游网';
		document.body.scrollTop = document.documentElement.scrollTop = 0;
		// store.dispatch('savePaths', newPaths);
	} else if (to.path.split('/').length === 2) {
		// 一级菜单，设置标签名称
		document.title = '峨眉山旅游网-' + to.meta.title;
		// newPaths.push({
		//     path: to.path,
		//     meta: to.meta
		// });
		// store.dispatch('savePaths', newPaths);
	}
	// else {
	//     let paths = store.getters.paths;
	//     paths.push({
	//         path: to.path,
	//         meta: to.meta
	//     });
	//     store.dispatch('savePaths', paths);
	// }
	next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js